import React, { memo } from 'react';
import styles from '../CartItems.module.scss';
import cn from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TouchableDiv } from '@components/common/Touchable';
import { changeCheckOrdersTab } from '@reducers/orders';
import { LABEL } from '@veriables';
import { cartTypes } from '../CartHelper';

const CartItemsTab = ({
  newItemsStyle,
  sentCount,
  pendingCount,
  handleSelectAll,
  isAllSelected,
  ...props
}) => {
  const {serverAppTheme, isPendingList, isCartLoading, changeCheckOrdersTab} = props;
  const visibleCartTypes = cartTypes.filter(cartType => cartType.show);

  if (isCartLoading) {
    return (
      <div className={cn('border-color-secondary border-primary col-12 row mx-0 px-0 justify-content-center align-items-center')}
        style={{ height: '32px', minHeight: '32px' }}
      >
        <div className="h-85 col-12 row mx-0 px-0 justify-content-center">
          <div className={cn('col-2 p-0 m-0 d-flex justify-content-start align-items-center')}>
            <div className={cn(styles.shimmer, 'ml-1')} style={{ width: '2vw', height: '2vw', borderRadius: '2px' }} />
          </div>
          <div className={cn('row mx-0 col-10 px-0 rounded-lg')} style={{ gap: 2 }}>
            <div className={cn(styles.shimmer, 'h-100 col rounded-left border-right-0')} />
            <div className={cn(styles.shimmer, 'h-100 col rounded-right')} />
          </div>
        </div>
      </div>
    );
  }

  const activeCount = isPendingList ? pendingCount : sentCount;

  return (
    <div
      className={cn(
        'border-color-secondary border-primary col-12 row mx-0 px-0 justify-content-center align-items-center'
      )}
      style={{ height: '32px', minHeight: '32px' }}
    >
      <div className="h-85 col-12 row mx-0 px-0 justify-content-center">
        <div className={cn('col-2 p-0 m-0 d-flex justify-content-start align-items-center', activeCount === 0 && 'd-none')}>
          {activeCount > 0 && (
            <input type="checkbox"
              className={cn(styles.checkbox, 'ml-1')}
              style={newItemsStyle.itemsStyle}
              checked={!!isAllSelected}
              onChange={(e) => handleSelectAll({isChecked: e.target.checked, isTabSwitched: false})}
            />
          )}
        </div>
        <div className={cn('row mx-0 px-0 rounded-lg', activeCount > 0 ? 'col-10' : 'col-12')}>
          {cartTypes?.map(({ key, label, refKey, show }) => {
            let tabStyles = newItemsStyle.inActiveTab;
            switch (true) {
              case key === 'pending' && pendingCount > 0:
                tabStyles = newItemsStyle.pendingTabBg;
                break;
              case key === 'pending' && isPendingList:
                tabStyles = newItemsStyle.activeTab;
                break;
              case !isPendingList && key === 'sent':
                tabStyles = newItemsStyle.activeTab;
                break;
            }
            return (
              show && (
                <TouchableDiv
                  id={key}
                  key={key}
                  role="presentation"
                  className={cn(
                    'h-100 col row mx-0 justify-content-center p-0 fw-600 position-relative',
                    key === 'sent'
                      ? 'rounded-right'
                      : visibleCartTypes?.length === 1 &&
                        visibleCartTypes[0]?.key === 'pending'
                        ? 'rounded'
                        : 'rounded-left border-right-0'
                  )}
                  style={tabStyles}
                  onClick={() => {
                    // setRefType(refKey);
                    // setActiveTab(key);
                    // handleSelectAll(key === 'sent' ? 1 : 0, false);
                    changeCheckOrdersTab({
                      isPendingList: label === LABEL().PENDING ? true : false,
                    });
                    handleSelectAll({isChecked: false, isTabSwitched: true});
                  }}
                  rippleEffect={true}
                >
                  <div
                    className={cn(
                      'col w-600 fs_12 p-0 text-center d-flex align-items-center justify-content-center h-100'
                    )}
                  >
                    {label}{' '}
                    {key === 'sent'
                      ? `(${sentCount || 0})`
                      : `(${pendingCount || 0})`}
                  </div>
                </TouchableDiv>
              )
            );
          })}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ orders, theme }) => ({
  isPendingList: orders.isPendingList,
  isCartLoading: orders.isCartLoading,
  serverAppTheme: theme.serverAppTheme,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ changeCheckOrdersTab }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(memo(CartItemsTab));
